<template>
<div class="twitter-post-preview-body">  
  <div v-if="msg" class="twitter-post-preview-body__msg" v-html="msg"></div>
  <div v-if="title || description || image" class="twitter-post-preview-body__framed">
    <shared-social-post-preview-image :title="title" :image="image" max-width="100%" padding="20px" />
    <div class="twitter-post-preview-body__content">      
      <div v-if="title" class="twitter-post-preview-body__title">
        {{ title }}
      </div>
      <div v-if="description" class="twitter-post-preview-body__description" v-html="description"></div>
    </div>
  </div>
  </div>  
</template>

<script>
import {extractSocialPostStepPieces} from '../../mixins/extractSocialPostStepPieces.mixin';
import SharedSocialPostPreviewImage from '../shared/SharedSocialPostPreviewImage';
export default {
  mixins: [extractSocialPostStepPieces],
  props: {
    pieces: Array,
  },
  components: {SharedSocialPostPreviewImage},
};
</script>

<style lang="scss" scoped>
@import '../../../../../../../sass/web/_variables';
.twitter-post-preview-body {
  &__framed{
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 19px;
    overflow: hidden;
  }
  &__content {
    padding: 0 15px;
    font-size: 14px;
  } 
  &__title,
  &__description {
    color: $black-color;
    word-break: break-word;
  }
  &__title {
    font-weight: bold;
    margin-bottom: 5px;
    margin-top: 5px;
  }
  &__description {
    color: $color-shuttle-grey;
    margin-bottom: 10px;
  }
  &__msg {
    padding-bottom: 5px;
    font-size: 14px;
  }
}
</style>